export default (axios, baseURL) =>
  async (clientSid, { subjects, classes, cocurriculums, readFromCache } = {}, queryParam = {}) => {
    const url = `/v2/clients/${clientSid}/students`;
    const axiosConfig = {
      method: 'GET',
      baseURL,
      url,
      headers: {
        'x-impersonated-client-sid': clientSid
      },
      params: {
        ...(subjects ? { subjects } : {}),
        ...(classes ? { classes } : {}),
        ...(cocurriculums ? { cocurriculums } : {}),
        ...(readFromCache !== undefined ? { readFromCache } : {}),
        ...queryParam
      }
    };
    const axiosResponse = await axios(axiosConfig);
    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  };
